import Breadcrumbs from 'molecules/Breadcrumbs';
import Section from 'molecules/Section';

import { generateBreadcrumbs } from 'components/Hero/PostHero/utils/helpers';

import type { FC } from 'react';
import type { PostUnion } from 'types';

interface WebinarPostHeroProps {
  post: PostUnion;
}

const WebinarPostHero: FC<WebinarPostHeroProps> = ({ post }) => {
  const { contentful_id, displayBreadcrumbs } = post;

  const breadcrumbs = generateBreadcrumbs(post);

  return (
    <Section padding="small" contentfulId={contentful_id}>
      <Breadcrumbs visible={displayBreadcrumbs} breadcrumbs={breadcrumbs} isDarkTheme={false} />
    </Section>
  );
};

export default WebinarPostHero;
